import { callAPI } from '@/shared/fetch_client';
import { Logger } from '@/shared/logger/logger';
export type ShopifyCart = {
  [key: string]: any;
  attributes: {
    [key: string]: string;
    waid_production: string;
  };
  cart_level_discount_applications: any[];
  currency: string;
  item_count: number;
  items: {
    [key: string]: any;
    discounted_price: number;
    discounts: any[];
    featured_image: {
      alt: string;
      aspect_ratio: number;
      height: number;
      url: string;
      width: number;
    };
    final_line_price: number;
    final_price: number;
    gift_card: boolean;
    grams: number;
    handle: string;
    has_components: boolean;
    id: number;
    image: string;
    key: string;
    line_level_discount_allocations: any[];
    line_level_total_discount: number;
    line_price: number;
    options_with_values: {
      name: string;
      value: string;
    }[];
    original_line_price: number;
    original_price: number;
    presentment_price: number;
    price: number;
    product_description: string | null;
    product_has_only_default_variant: boolean;
    product_id: number;
    product_title: string;
    product_type: string;
    properties: Record<string, any>;
    quantity: number;
    quantity_rule: {
      increment: number;
      max: number | null;
      min: number;
    };
    requires_shipping: boolean;
    sku: string;
    taxable: boolean;
    title: string;
    total_discount: number;
    url: string;
    variant_id: number;
    variant_options: string[];
    variant_title: string;
    vendor: string;
  }[];
  items_subtotal_price: number;
  note: string;
  original_total_price: number;
  requires_shipping: boolean;
  token: string;
  total_discount: number;
  total_price: number;
  total_weight: number;
};

export const ShopifyCartApi = {
  async fetchCart(): Promise<any> {
    try {
      const options = {
        method: 'GET',
        retries: 3,
        url: '/cart.js',
      };
      const response = await callAPI<ShopifyCart>(options, undefined, true);
      if (!response.data?.token) {
        Logger.warn('Did not recieve cart with token', response);
        return null;
      }
      return response;
    } catch (error: any) {
      Logger.error('Failed to fetch cart', error);
    }
  },

  async updateCart(attributes: any): Promise<object | null> {
    try {
      const options = {
        body: JSON.stringify({ attributes }),
        method: 'POST',
        retries: 3,
        url: '/cart/update.js',
      };
      const response = await callAPI<object>(options, undefined, true);
      return response;
    } catch (error: any) {
      Logger.error('Failed to update cart', error);
      return null;
    }
  },
};
